import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function CijenaLegalizacijePage() {
  return (
    <div data-testid="cijena-legalizacije-page">
      <Seo
        title="Cijena legalizacije"
        description="Saznajte što utječe na cijenu legalizacije objekta i kako izgleda okvirna procjena troškova postupka."
        path="/cijena-legalizacije"
      />

      <section className="border-b border-hair">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-16 lg:pt-28 lg:pb-20">
          <div className="overline text-ink-soft">Troškovi i procjena</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] font-bold text-ink mt-6">
            Cijena<br />
            <span className="text-ink/40">legalizacije</span>
          </h1>
          <p className="text-ink-soft leading-relaxed max-w-3xl mt-8">
            Cijena legalizacije ovisi o vrsti objekta, površini, lokaciji i
            potrebnoj dokumentaciji. Pripremamo jasnu i transparentnu ponudu bez
            skrivenih troškova.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        <article className="md:col-span-8 space-y-6 text-ink-soft leading-relaxed">
          <h2 className="font-display text-3xl text-ink">Što ulazi u cijenu</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>geodetska snimka i pripadajući elaborati</li>
            <li>arhitektonski snimak izvedenog stanja</li>
            <li>priprema i predaja dokumentacije nadležnim tijelima</li>
            <li>vođenje predmeta do rješenja i upisa</li>
          </ul>
          <h2 className="font-display text-3xl text-ink">Kako dobiti točnu ponudu</h2>
          <p>
            Za točnu procjenu potrebno je nekoliko osnovnih informacija o objektu.
            Nakon pregleda podataka šaljemo okvirnu cijenu i predloženi plan rada.
          </p>
        </article>

        <aside className="md:col-span-4 border border-hair p-6 bg-white h-fit">
          <div className="overline text-ink-soft">Brza procjena</div>
          <p className="text-ink-soft mt-3 text-sm leading-relaxed">
            Ispunite prijavu i dobit ćete informativnu procjenu troškova i rokova.
          </p>
          <Link
            to="/prijava"
            className="inline-flex items-center gap-2 mt-5 bg-ink text-white px-5 py-3 text-sm font-medium rounded-sm hover:bg-[#112240] transition-colors"
          >
            Zatraži procjenu
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
          </Link>
        </aside>
      </section>
    </div>
  );
}
